import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import SignOut from "@/pages/auth/SignOut";
import VerifyOTP from "@/pages/auth/VerifyOTP";
import Products from "@/pages/dashboard/Products";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/products" replace />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-out" element={<SignOut />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/products" element={<Products />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
